import styled, { css } from "styled-components";

import { Select } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageSelect/styles";
import { ConsolePageTextAreaContainer } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageTextArea/styles";

export const SingleOrderContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0;

  height: 100%;

  padding: 6rem 1rem;

  background-color: ${({ theme }) => theme.orders.pageBackgroundColor};

  @media (max-width: 990px) {
    padding-top: 2rem;
  }
`;

export const SingleOrderContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  max-width: 1000px;

  gap: 2.5rem;

  h3 {
    font: 600 0.813rem/1.016rem "Inter";
    color: ${({ theme }) => theme.groups.primaryText} !important;
    padding: 0.5rem 0;
  }

  .status {
    position: relative;
    padding-left: 0.75rem;

    ::before {
      content: "";
      position: absolute;

      top: 40%;
      left: 0;

      height: 5px;
      width: 5px;

      border-radius: 50%;
    }
  }

  .canceled::before {
    background-color: #c2c2c2;
  }

  &.paid::before,
  &.finished::before {
    background-color: #48ff51;
  }

  &.failed::before,
  &.unpaid::before,
  &.cancelled::before,
  &.refused::before,
  &.chargeback::before,
  &.refunded::before {
    background-color: #ec3434;
  }

  &.charged::before,
  &.waiting_payment::before,
  &.pending::before {
    background-color: #0073e5;
  }
`;

export const singleOrderBackgroundTransparentModal = (show) => css`
  position: fixed;

  top: 0;
  left: 0;

  display: grid;
  place-items: center;

  backdrop-filter: blur(4px);

  width: 100vw;
  height: 100%;

  padding: 1rem;

  background: ${({ theme }) => theme.orders?.modalBackground}33;

  pointer-events: ${show ? "all" : "none"};
  z-index: ${show ? "100" : "-1"};
  opacity: ${show ? "1" : "0"};

  transition: all 0.2s ease-in-out;
`;

export const singleOrderBackgroundModal = css`
  transition: all 0.2s ease-in-out;

  background: ${({ theme }) => theme.orders?.cardBackground};

  border-radius: 1rem;

  max-width: 32.813rem;

  padding: 2rem;

  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    padding: 1rem;
  }

  > h3 {
    all: unset;
    font: 600 1.125rem/150% "Inter";
    color: ${({ theme }) => theme.console.pageTitleColor} !important;
    margin-bottom: 0.5rem;
  }

  > h5 {
    all: unset;
    font: 400 0.813rem/150% "Inter";
    color: ${({ theme }) => theme.console.pageSubtitleColor} !important;
  }
`;

export const singleOrderBackgroundModalHeader = css`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;

  justify-content: space-between;

  h1 {
    all: unset;

    font: 500 0.813rem/150% "Inter";
    color: ${({ theme }) => theme.controlPanel?.textControlPanel};
    letter-spacing: 0;
  }

  button {
    padding: 0.25rem;

    :hover:not(:disabled) {
      background-color: ${({ theme }) => theme.console.modalHover};
    }
  }

  svg {
    height: 1.125rem;
    width: 1.125rem;

    * {
      stroke: ${({ theme }) => theme.console.pageTitleColor};
    }
  }
`;

export const singleOrderModalInputStyle = css`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  #admin-console-cancel-recurrence-remove-file-button {
    width: fit-content;
    border: 1px solid ${({ theme }) => theme.orders?.cardBorder};
  }

  > span {
    font: 400 0.813rem/150% "Inter";
    color: ${({ theme }) => theme.console.pageSubtitleColor} !important;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
`;

export const singleOrderModalFormStyle = css`
  transition: all 0.2s ease-in-out;

  gap: 1rem;
  display: flex;
  flex-direction: column;

  margin: 1.5rem 0;

  textarea {
    min-height: 6.25rem;
  }

  .refund-request-form-content {
    display: flex;

    gap: 0.125rem;
  }

  input,
  label,
  textarea,
  ${ConsolePageTextAreaContainer}, ${Select} {
    background-color: transparent;
  }

  [name="reason_description"] {
    min-height: 100px;

    :invalid:not(:disabled) {
      box-shadow: 0px 0px 0px 2px #ec3434;
    }
  }

  [data-testid="console-page-select-options"] {
    background-color: ${({ theme }) => theme.orders?.cardBackground};
  }
`;

export const singleOrderModalAttachmentStyle = css`
  display: flex;
  flex-direction: column;

  margin-top: 0.5rem;

  p,
  span {
    all: unset;
    vertical-align: middle;
    letter-spacing: 0;
  }

  > p {
    font: 600 0.813rem/150% "Inter";
    color: ${({ theme }) => theme.console.pageTitleColor} !important;
  }

  > p > i {
    font: 400 0.75rem/150% "Inter";
    font-style: italic;
    color: ${({ theme }) => theme.console.pageSubtitleColor} !important;
  }

  > span {
    font: 400 0.813rem/150% "Inter";
    color: ${({ theme }) => theme.console.pageSubtitleColor} !important;
  }
`;

export const singleOrderModalCancelButtonStyle = css`
  padding: 0.75rem 2rem;
  border-radius: 0.25rem;
  width: 100%;

  border: 1px solid #0073e5;
  border-radius: 0.25rem;
  background: #0073e5;

  font-size: 1rem;
  font-weight: 500;
  color: #f2f2f2;

  cursor: pointer;
  transition: background-color 300ms;

  &:hover {
    background: #0073e5cc;
  }
`;

export const singleOrderModalFooterStyle = css`
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    flex-direction: flex;
    gap: 1rem;
  }

  button {
    width: 93%;
  }

  .loader {
    height: 1rem;
    width: 1rem;
  }

  [form="refund-request-form"],
  [form="cancel-recurrence-form"] {
    min-width: 9rem;
  }
`;
